export default __webpack_public_path__ + "static/media/Pin_Job_FlatTire.edc6b8d6.svg";